<template>
  <div v-if="component && component.properties" ref="control" :class="['report-column-edit-input', column.lineWrap && 'report-column-edit-column-normal']">
    <div class="input" :style="{'height': column.lineWrap && controlHeight, 'minHeight': controlMinHeight}" v-if="edit && !component.properties.readonly && !component.properties.hidden">
      <el-input :class="error !== '' && 'is-error'" ref="input" v-model="value" @blur="updateValue" @keyup.enter.native="updateValue" @keyup.esc.native="cancel" :placeholder="component.properties.placeholder"></el-input>
    </div>
    <template v-else>
      <template v-if="component.properties.readonly || component.properties.hidden">
        <el-tooltip v-if="showTooltip && !column.lineWrap" effect="dark" :content="formatter(value, 'content')" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}"><span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span></div>
        </el-tooltip>
        <div v-else class="span">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}"><span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span></div>
        </div>
      </template>
      <template v-else>
        <el-tooltip v-if="showTooltip && !column.lineWrap" effect="dark" :content="formatter(value, 'content')" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
            <span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span>
            <i class="el-icon-edit" @click.stop="openInput"></i>
          </div>
        </el-tooltip>
        <div v-else class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
          <span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span>
          <i class="el-icon-edit" @click.stop="openInput"></i>
        </div>
      </template>
    </template>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
import publicMixin from './mixin'
export default {
  name: 'rept-rc-input',
  mixins: [publicMixin],
  watch: {
    data: {
      handler (val) {
        this.value = val[this.column.id]
        this.error = ''
        this.edit = false
        this.getShowTooltip()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .report-column-edit-input {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .span {
      font-size: 13px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
      height: 100%;
      line-height: 42px;
      span {
        font-size: 13px;
      }
      .el-icon-edit {
        position: absolute;
        right: 3px;
        top: calc(50% - 7px);
        cursor: pointer;
        color: #C2C3C4;
        display: none;
        &:hover {
          color: #55acf1;
        }
        &:active {
          color: #3079df;
        }
      }
      &:hover {
        .el-icon-edit {
          display: inline-block;
        }
      }
    }
    .input {
      width: 100%;
      height: 100%;
      .el-input {
        // .pagination-list .el-main .content .el-input 覆盖了
        width: 100% !important;
        height: 100%;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        .el-input__inner {
          width: 100%;
          // .pagination-list .el-main .content .el-input .el-input__inner 这个样式覆盖了
          height: 100% !important;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
          font-size: 13px;
          color: #000;
        }
      }
    }
    .is-error {
      border-color: #F05459 !important;
      .el-input__inner {
        border-color: #F05459 !important;
      }
    }
    .error-message {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 2;
      background-color: #FEECEC;
      color: #F05459;
      border: 1px solid #F05459;
      padding: 0 5px;
      border-top: none;
      text-align: left;
      font-size: 12px;
    }
  }
  .report-column-edit-column-normal {
    position: relative;
    .span{
      white-space: normal;
      line-height: 26px;
      padding: 5px 25px 5px 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/reportColumnEdit/rc-input.vue